import { ChangeDetectionStrategy, Component, effect, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { AbstractDynamicComponent } from '@components/abstracts';
import { BoutonFiltreFaq } from '@components/bouton-filtre-faq/models';
import { ElasticSearchService } from '@shared/services/elastic-search';
import { UrlParamsService } from '@shared/services/url-params';
import { FaqStore } from '@stores';

@Component({
  selector: 'app-bouton-filtre-faq',
  templateUrl: './bouton-filtre-faq.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink],
})
export class BoutonFiltreFaqComponent extends AbstractDynamicComponent<BoutonFiltreFaq> {
  protected readonly currentCategory = inject(FaqStore).select('currentCategory');
  private readonly elasticSearchService = inject(ElasticSearchService);
  protected readonly categories = toSignal(this.elasticSearchService.getFaqCategories(), { initialValue: [] });
  private readonly urlParamsService = inject(UrlParamsService);
  protected readonly filter = this.urlParamsService.param('categorie');

  constructor() {
    super();
    effect(() => {
      const filter = this.filter();
      const faqListUrl = this.data.faqListUrl;
      const defaultCategory = this.categories()?.[0]?.name;
      if (!filter && !faqListUrl && defaultCategory) {
        this.urlParamsService.mergeParams({ categorie: defaultCategory });
      }
    });
  }
}
